<template src="./PackageModule.html"></template>

<script>
import Vue from "vue";

// import '@progress/kendo-theme-default/dist/all.css'
import { Grid } from "@progress/kendo-vue-grid";
import { saveExcel } from "@progress/kendo-vue-excel-export";
import CommandCellTemplate from "@/components/CommandCellTemplate/CommandCellTemplate";
import PackageFeatureManagement from "@/components/CommandCellTemplate/PackageFeatureManagement";
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("packageModules");
import { orderBy } from "@progress/kendo-data-query";

Vue.component("Grid", Grid);

export default {
  data: function() {
    return {
      skip: 0,
      take: 10,
      pageSize: 10,
      search: "",
      sort: [{ field: "id", dir: "asc" }],
      pageTitle: "List modules",

      columns: [
        { field: "id", title: "ID", hidden: true},
        { field: "name", title: "Name" },
        {
          cell: PackageFeatureManagement,
          hidden: true,
          title: "Features",
          width: "200px"
        },
        { cell: CommandCellTemplate, title: "Actions", width: "200px" }
      ],
      dataItem: []
    };
  },

  methods: {
    pageChangeHandler: function(event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    sortChangeHandler: function(e) {
      this.sort = e.sort;
    },
    packageModules: function() {
      this.$store.dispatch("packageModules/getPackages");
    },
    addNewModule: function() {
      this.$router.push({ name: "AddUpdateModule", path: "/package/add" });
    },
    exportExcel: function() {
      saveExcel({
        data: this.result,
        fileName: "modules",
        columns: [{ field: "id" }, { field: "name" }]
      });
    }
  },
  computed: {
    result: function() {
      const modules = this.$store.state.packageModules.package;
      return modules;
    },
    ...mapState({
      packages: state => state.package
    }),
    total() {
      if(this.search){
        return this.items ? this.items.length : 0;
      }else{
        return this.packages ? this.packages.length : 0;
      }
    },
    items: {
      get: function() {
        if(this.search){
            let data = this.packages.filter(pack => `${pack.productName}${pack.name}`.match(new RegExp(this.search, "i")));
            return orderBy(data.slice(this.skip, this.take + this.skip), this.sort);
         }else{
              return orderBy(
                this.packages.slice(this.skip, this.take + this.skip),
                this.sort
              );
         }
      }
    }
  },
  mounted: function() {
    this.packageModules();
  }
};
</script>

<style scoped >
.contentsSec {
  margin: 10px;
}
.pageTitle {
  padding-bottom: 10px;
}
.pageContaint {
  margin: 10px;
}
</style>